if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.ppRemoveUnsafeUnicodeCharacters
) {
  Object.defineProperty(String.prototype, 'ppRemoveUnsafeUnicodeCharacters', {
    value() {
      return this
        .split('')
        .filter((character, index) => (
          this.charCodeAt(index) <= 127
          || (
            this.charCodeAt(index) >= 160
            && this.charCodeAt(index) <= 255
          )
        ))
        .join('');
    }
  });
}